var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_446_63",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_446_63",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAACgUlEQVRoge2ZsWtUQRCHfxMLEZJaYhQMkahFQINdDObSilgoWqRX0tqowUL8A7TU3oBoZbi0IkhQAyJ2nhErm6iHBE1zUfNZvHdyanI3+27vFvQ+eNWbnf1mb3eO5Uk9evzfWKxEgEkal3Ra0qSkQUl789fvJa1KeiJpwcxexpq3bQADzgFv8FMBzuZFJ5UfAZYDxP/kGTCcSv448KEN+TpVYLrb8iVgI4J8nRpwolvyw8DHiPJ1qsCBTssb7e35VjylkwcbON9B+TpnQpzc1eYrU5E0Glp4IBUzO+wN7gtIPC6//IKkKUn9+VOSVHaOPQQcDfDyAdxwboHLTXLMOXNc70QBjx0TP3TkKTvyPPJ6hWyhPY6YW46Ym46YIUeMpLBD/FXZfm7GgJmtt8gzIOlLizzrZjbg8Qr5BUJim+FZNPfChkh9csQcixTjmUtSWAEVR8ylSDGeuSSFFbDsiDkFzG33Ergm6WSkucIAJpw9nLxVloD+/JkGFgPGT3i9QrpQn7KroaedtsOqpCEz2/QEu7dQnvBeUasA5r3yUuClHhiRtKJ4LfWvKSQdNLO33gFBImb2TtJiqFUA5RD5QgBjwI+AA+llEzjSUfmGIh50oID7XZHPCxgFvkWU/w64LzGNFDqMZrYiab7I2G24a2avI+ZrDbAb+Bxh9deAwa7KNxRxMUIBF5LI5wX0AUttyD8n+4dPB1lbrRWQrwFjSeXrAFcLFHAltfcvyLaS59JfZwnYkdr7N4B9+LrSGrA/te+WADOOAmZSezYFuNNE/nZqv5YAO4EXW8i/Anal9nNB9g2h2iBfJdWnpKIAk2S9foNuf0KKBTALzKb26NHjX+YneAbqEdKkjSkAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.937436924da1843de2b37c8c953b66a4.svg";
export { ForwardRef as ReactComponent };